import { Model } from 'pinia-orm';
import { BelongsTo, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Package from './Package';
import Project from './Project';
import VariationOrder from './VariationOrder';
/* --- user header --- */
/* --- end user header --- */

export default class VariationOrderCategory extends Model {
  static entity = 'App\\Models\\VariationOrderCategory';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare project_id: number;
  @Num(undefined)
  declare package_id: number | undefined;
  @Num(0)
  declare sort_order: number;
  @Str('')
  declare description: string;
  // relations
  @BelongsTo(() => Project, 'project_id', 'id')
  declare project: Project;
  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package | undefined;
  @HasMany(() => VariationOrder, 'variation_order_category_id', 'id')
  declare variation_orders: VariationOrder[];
  /* --- user code --- */
  /* --- end user code --- */
}
